import { useCallback } from 'react';
import { removeFromStorage, getFromStorage, collectFingerprint, getPublicIpAddress } from '@/utils';
import { useCleanupReferralFingerprintMutation } from '@/store/api';

export function useCleanupReferral() {
	const [cleanupFingerprint] = useCleanupReferralFingerprintMutation();

	return useCallback(async () => {
		const referralCode = getFromStorage();
		if (referralCode) {
			const fingerprint = collectFingerprint();
			const ipAddress = await getPublicIpAddress();
			await cleanupFingerprint({ referralCode, fingerprint, ipAddress }).unwrap();
		}
		removeFromStorage();
	}, [cleanupFingerprint]);
}
